import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {TextArea} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"

const MAX_CHAR_LENGTH = 280

export const schema = (intl) =>
  Validation.string(intl.formatMessage({id: "platform.defaultValidation.required"})).max(
    intl.formatNumber(MAX_CHAR_LENGTH),
    intl.formatMessage({id: "recognition.customReward.validation.maxLength"}, {count: intl.formatNumber(MAX_CHAR_LENGTH)})
  )

const PROPERTY = "desc"

export const CUSTOM_REWARD = (intl) => ({
  href: "https://res.cloudinary.com/perkbox/image/upload/v1524834883/e087430d-1131-4e5b-8f36-e24afe341785.png",
  alt: intl.formatMessage({id: "recognition.customReward.default.alt"}),
  isCustom: true,
  desc: intl.formatMessage({id: "recognition.customReward.default.desc"})
})

const StyledTextArea = styled(TextArea)`
  width: 80%;
  margin-bottom: 0;
  textarea {
    resize: vertical;
  }
`

class Desc extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string
  }

  static defaultProps = {
    value: null,
    validation: null,
    label: "recognition.customReward.label",
    placeholder: "recognition.customReward.placeholder",
    id: "reward"
  }

  static getDerivedStateFromProps(props, prevState) {
    const {intl} = props
    return {
      validation: props.validation || prevState.validation || schema(intl)
    }
  }

  render() {
    const {value, onChange, ...props} = this.props

    return (
      <StyledTextArea
        rows={3}
        {...props}
        onChange={onChange}
        name={id(PROPERTY, this.props)}
        id={id(PROPERTY, this.props)}
        value={value}
      />
    )
  }
}

export default injectIntl(Desc)
